import React from 'react';
import { BBLForeverYoung } from './pages/BBLForeverYoung';
export function App() {
  return <BBLForeverYoung data-id="element-0" />;
}